export const USER_API = {
  USER_QRLOGIN: '/users/qrlogin',
  PROMOTION_PACKAGE: '/transaction/package-list',
  TODAY_BET: '/transaction/bets/aggregation',
  DEPOSIT_MOMO: '/transaction/add-invoice-momo',
  TRANSFER_WALLET: '/wallet/transfer',
  INVOICE_STATUS: '/transaction/invoice-status',
  ADD_BANK_ACCOUNT: '/users/bank-account'
}

// Auth Module
export const AUTH_API = {
  REGISTER: '/users/register',
  LOG_IN: '/users/login',
  LP_TOKEN_LOG_IN: '/users/lptoken-login',
  LOG_OUT: '/users/logout',
  FORGOT_PASSWORD: '/users/reset-password',
  UPDATE_RESET_PASSWORD: '/users/update-reset-password',
  UPDATE_PASSWORD: '/users/update-password'
}

// Profile Module
export const PROFILE_API = {
  UPDATE_PROFILE: '/users/profile/update',
  PROFILE: '/users/profile',
  CHECK_EMAIL: '/users/checkEmailExists',
  UPDATE_AVATAR: '/users/profile/avatar',
  CHECK_PHONE: '/users/checkPhoneExists',
  CHECK_DISPLAYNAME: '/users/checkFullnameExists',
  CHECK_USERNAME: '/users/checkUserExists'
}

// Transaction Module
export const TRANSACTION_API = {
  ACCOUNT_PLAN: '/transaction/promotion',
  CANCEL_PROMOTION: '/transaction/cancel-promotion',
  SEND_CONTACT_EMAIL: '/users/send-contact-email',
  TRANSACTION_HISTORY: '/transaction/history',
  TRANSACTION_GAME: '/transaction/history-bet',
  BANK_LIST: '/transaction/bank-list',
  USER_BANKS: '/users/banks'
}

// Deposit and Withdraw Module
export const DEPOSIT_WITHDRAW_API = {
  DEPOSIT_BANK: '/transaction/add-invoice',
  DEPOSIT_MOMO: '/transaction/add-invoice-momo',
  DEPOSIT_CARD: '/transaction/add-invoice-phone-card',
  DEPOSIT_QRPAY: '/transaction/nicepay-invoice',
  WITHDRAW_BANK: '/transaction/add-invoice-withdraw',
  WITHDRAW_BANK_LIST: '/transaction/withdraw-banks',
  WITHDRAW_CARD: '/transaction/add-invoice-withdraw-phone',
  BANK_ACCOUNT: '/transaction/bank-account',
  PHONE_CARD_LIST: '/transaction/phone-card',
  EWALLET_LIST: 'transaction/ewallet-list',
  BANK_SCHEDULE: '/transaction/bank-schedule',
  WITHDRAW_CRYPTO: '/transaction/add-invoice-withdraw-crypto',
  DEPOSIT_TPAY: '/transaction/tpay-invoice',
  TPAY_STATUS: 'transaction/tpay-status'
}

// Transfer Module
export const TRANSFER_API = {
  TRANSFER: 'transaction/exchange',
  GET_LIST_AGENCY: 'users/bet-accounts'
}

// Crypto Module
export const CRYPTO_API = {
  CRYPTO_LIST: '/transaction/crypto',
  INVOICE_STATUS: '/transaction/invoice-status',
  ADD_INVOICE_CRYPTO: '/transaction/add-invoice-crypto',
  CANCEL_INVOICE_CRYPTO: '/transaction/cancel-crypto-invoice'
}

// Payment Code Module
export const PAYMENT_CODE_API = {
  MOMO_CODE: 'transaction/ewallet-code'
}

// Maintenance Module
export const MAINTENANCE_API = {
  USER_MAINTENANCE: 'users/maintenance'
}

export const BETTING_TRIAL_ACCOUNT = {
  TRIAL_ACCOUNTS: 'users/trial-accounts'
}

export * from './games'
export * from './cms'
export * from './media'
